<template>
  <v-row class="" v-if="this.$store.state.toggleCat">
    <v-col>
      <v-btn text block class="text-capitalize btn-left back-btn" @click="toggle();">
        <v-icon class="back-icon"></v-icon>
        Menù
      </v-btn>
      <div class="cat-content mx-5">
      <h2 class="secondary-color cat-title">{{this.$store.state.currentMenu.title}}</h2>
      <p style="white-space: pre-line;" class="cat-title-desc">{{this.$store.state.currentMenu.descr}}</p>
      </div>
      <div v-for="(cat, index) in getCatById.categories" :key="`cat-${index}`">
        <v-btn text block class="justified-btns h2 mb-2 cat-btns" @click="toggleItems();currentCat(cat);">
          {{cat.title}}
          <v-icon class="next-icon"></v-icon>
        </v-btn>
      </div>
    </v-col>
    <!-- <items-menu></items-menu> -->
  </v-row>
</template>

<script>
// import ItemsMenu from "@/components/ItemsMenu";

export default {
  name: "CatMenu",
  components: {
    // ItemsMenu
  },
  data() {
    return {
    };
  },
  methods: {
    toggle() {
      this.$store.commit('setToggleMenu');
      this.$store.commit('setToggleCat');
    },
    toggleItems() {
      this.$store.commit('setToggleCat');
      this.$store.commit('setToggleItems');
    },
    currentCat(cat){
      this.$store.commit('setCurrentCat', cat);
    }
  },
  computed: {
      getCatById () {
          return this.$store.getters.getCatById(this.$store.state.currentMenu.menuId)
      }
  }

};
// console.log(this.$store.getters.getCatById(currentMenu.menuId));
</script>
